module.exports = __webpack_public_path__ + "media/ringtone.250519d9.wav";